export enum IdentificationTypeEnum {
    BELGIAN_ID_CARD = "belgianIdCard",
    BELGIAN_RESIDENT_CARD = "belgianResidentCard",
    OTHER_ID = "otherId",
}